




















































import { PropType, defineComponent } from '~/utils/nuxt3-migration'
import GoogleRatingStars from '~/components/car/classifieds/view/partials/google-rating/GoogleRatingStars.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { DealerGoogleRating } from '~/models/dealer/types'

export default defineComponent({
  components: {
    GoogleRatingStars,
    CImg
  },
  props: {
    googleRating: {
      type: Object as PropType<DealerGoogleRating>,
      required: true
    },
    noBorder: { type: Boolean, required: false, default: false },
    noShadow: { type: Boolean, required: false, default: false },
    whiteBackground: { type: Boolean, required: false, default: false },
    withoutSellerName: { type: Boolean, required: false, default: false },
    logoSize: {
      type: String as PropType<'lg' | 'sm'>,
      default: 'lg'
    }
  }
})
